export function extractAttrs(element: HTMLElement, removeDataPrefix = true) {
	const attrs: any = {};
	if (!element){
		console.error("extractAttrs: element is null or undefined");
		return attrs;
	}
	
	for (let i in element.attributes){
		const attr = element.attributes[i];
		if (!attr.name)
			continue;
		if (!attr.name.startsWith("data-") )
			continue;
		const name = removeDataPrefix ? attr.name.substr(5)	: attr.name;
		attrs[name] = attr.value;
	}
	
	return attrs;
}

export function parseBool(val: string){
	if (!val)
		return false;
	return (val.toLowerCase() == "true");
}
